import { get } from "lodash";

// Expect Contentful rich text -> content -> json
export default function getHeadersFromRichText(json) {
  if (json == null || json.content == null) return [];
  return json.content
    .filter((c) => ["heading-2", "heading-3"].includes(c.nodeType))
    .map((c) => get(c, "content[0].value"))
    .filter((h) => h);
}
